import React from 'react'
import Select from 'react-select'
import { uniq } from 'lodash'

const ResourcesBar = ({ options, onChange, value }) => (
  <Select
    multi
    name="resources"
    onChange={onChange}
    options={uniq(options)}
    value={value}
    menuContainerStyle={{ zIndex: 999 }}
  />
)

export default ResourcesBar